import { Injectable, signal } from "@angular/core";
import { User } from "@domain/User";

@Injectable({
  providedIn: "root",
})
export class AuthState {
  currentUser = signal<User | undefined>(undefined);

  setCurrentUser(newCurrentUser: User) {
    this.currentUser.set(newCurrentUser);
  }

  deleteCurrentUser() {
    this.currentUser.set(undefined);
  }
}
